import { PageHero, CtaBlock, BrowserFrame, TextLink } from "@/components/site/Ui";
import { Clip, Reveal } from "@/components/site/Motion";
import Split, { Bullets } from "@/components/site/Split";
import { projects } from "@/content/site";
import { useSeo } from "@/lib/seo";

const pillars = [
  { t: "L'image", d: "Une direction artistique à la hauteur de votre établissement." },
  { t: "Les textes", d: "Courts, clairs, écrits pour vos clients et compris par Google." },
  { t: "La réservation", d: "Appel, rendez-vous, table, arrhes : au bon endroit, en un geste." },
];

export default function Studio() {
  const p = projects[0];
  useSeo({
    title: "Sanaa — web designer indépendante à Toulouse",
    description: "Sanaa, web designer à Toulouse : je conçois des sites sur mesure pour les commerces et les indépendants, avec une attention particulière à l'image, aux textes et à la réservation.",
    path: "/studio",
  });
  return (
    <>
      <PageHero testid="studio-hero" label="Le Studio" lines={["Sanaa —", "web designer indépendante."]}
        intro="Je conçois des sites sur mesure pour les commerces et les indépendants, avec une attention particulière à l'image, aux textes et à la réservation." />
      <section className="wrap pb-20">
        <Clip><BrowserFrame src={p.shots.s1} alt="Section soins du site Maison Sanaa" label={p.domain} /></Clip>
        <p className="mt-3 font-mono text-[13px] text-mute">Projet : {p.name} — <TextLink to={`/realisations/${p.slug}`} className="!text-[13px]">voir l'étude de cas</TextLink></p>
      </section>
      <section className="wrap grid gap-px bg-ink/15 pb-px md:grid-cols-3" data-testid="studio-pillars">
        {pillars.map((x, i) => (
          <Reveal key={x.t} delay={i * 0.08} className="bg-ivory py-8 md:px-8 md:first:pl-0">
            <p className="font-mono text-[13px] text-accent">0{i + 1}</p>
            <h2 className="display mt-3 text-[2.2rem]">{x.t}</h2>
            <p className="mt-2 leading-relaxed text-mute">{x.d}</p>
          </Reveal>
        ))}
      </section>
      <Split label="Comment je travaille" title="Un studio indépendant, un seul interlocuteur.">
        <p>Vous échangez avec moi du premier appel à la mise en ligne. Pas d'intermédiaire, des décisions rapides.</p>
        <Bullets items={["Direction artistique et web design", "Création de sites internet", "Réservation en ligne, arrhes, agenda", "Référencement local et fiche Google", "Suivi et hébergement"]} />
      </Split>
      <CtaBlock />
    </>
  );
}
